package com.eladfinish.bible.contest.screens.mikud.ui.dialogs

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.screens.mikud.mvi.MikudAction
import com.eladfinish.bible.contest.screens.mikud.mvi.MikudState
import com.eladfinish.bible.contest.ui.components.dialogs.BasicDialogWithTitle
import com.eladfinish.bible.contest.ui.components.verticalScrollWithScrollbar

@Composable
fun RemoteMikudMenuDialog(
    state: MikudState.DialogState.RemoteMikudMenu,
    onAction: (MikudAction) -> Unit,
    modifier: Modifier = Modifier,
) {
    BasicDialogWithTitle(
        title = state.title,
        onDismiss = { onAction(MikudAction.HideDialog) },
        onCancel = { onAction(MikudAction.HideDialog) },
    ) {
        Column(
            modifier = modifier
                .padding(16.dp)
                .heightIn(max = 400.dp)
                .verticalScrollWithScrollbar(),
            verticalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            state.items.forEachIndexed { index, item ->
                RemoteMikudMenuItemRow(
                    index = index,
                    name = item.name,
                    info = item.info,
                    createdAtText = item.createdAtText,
                    onClick = { onAction(MikudAction.RemoteMikudClicked(index)) },
                )
            }
        }
    }
}

@Composable
private fun RemoteMikudMenuItemRow(
    index: Int,
    name: String,
    info: String,
    createdAtText: String,
    onClick: () -> Unit,
) {
    // Surface gives you proper ripple & touch target when clickable
    Surface(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick),
        tonalElevation = 1.dp,
        shape = MaterialTheme.shapes.medium,
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp),
        ) {
            Text(
                text = "${index + 1}. $name",
                style = MaterialTheme.typography.bodyLarge,
            )

            if (info.isNotBlank()) {
                Text(
                    text = "\t\t($info)",
                    style = MaterialTheme.typography.bodySmall,
                )
            }

            Text(
                text = "\t\tנוצר ב: $createdAtText",
                style = MaterialTheme.typography.bodySmall,
            )
        }
    }
}
